<div class="replace-matcard">
  <mat-card-header>
    <h1 *ngIf="this.projectId < 1; else elseBlock">{{project?.addTitel}}</h1>
    <ng-template #elseBlock>
      <h1>{{project?.editTitel}}</h1>
    </ng-template>
  </mat-card-header>
  <mat-card-content class="card-content">
    <form [formGroup]="projectForm">
      <div class="form-container">

        <mat-form-field appearance="outline" class="width-100">
          <mat-label>{{project?.projectNameLabel}}</mat-label>
          <input matInput autoComplete="off" formControlName="name" (keypress)="disableKeyPressEnter($event,true)">
          <mat-error *ngIf="projectForm.get('name')?.hasError('maxlength')">
            {{project?.validation?.maxLength100}}
          </mat-error>
          <mat-error *ngIf="projectForm.get('name')?.hasError('required')">
            {{project?.validation?.required}}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="width-100">
          <mat-label>{{project?.projectDescriptionLabel}}</mat-label>
          <input matInput autoComplete="off" formControlName="description"
            (keypress)="disableKeyPressEnter($event,true)">
          <mat-error *ngIf="projectForm.get('description')?.hasError('maxlength')">
            {{project?.validation?.maxLength255}}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="width-100">
          <mat-label>{{project?.transportModeLabel}}</mat-label>
          <mat-select formControlName="transportModeId" (selectionChange)="changeTransportMode($event.value)">
            <mat-option class="select-without-checkbox" *ngFor="let transportMode of transportModes"
              [value]="transportMode.id">
              {{transportMode.name}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="projectForm.get('transportModeId')?.hasError('required')">
            {{project?.validation?.required}}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="width-100">
          <mat-label>{{project?.regionLabel}}</mat-label>
          <mat-select formControlName="regionId" (selectionChange)="changeRegion($event.value)">
            <mat-option class="select-without-checkbox" *ngFor="let region of regions" [value]="region.id">
              {{region.name}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="projectForm.get('regionId')?.hasError('required')">
            {{project?.validation?.required}}
          </mat-error>
        </mat-form-field>

        <mat-accordion>
          <mat-expansion-panel *ngIf="selectedRegion" hideToggle (opened)="panelOpenState = true"
            (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{project?.settingsTitel}}
              </mat-panel-title>
              <mat-panel-description>
                {{project?.settingsDescription}}
              </mat-panel-description>
              <mat-icon *ngIf="panelOpenState == false">add</mat-icon>
              <mat-icon *ngIf="panelOpenState == true">remove</mat-icon>
            </mat-expansion-panel-header>

            <div>
              <mat-form-field class="width-50">
                <mat-label>{{project?.comfortLabel}}</mat-label>
                <mat-select formControlName="comfortTypeId">
                  <mat-option class="select-without-checkbox" *ngFor="let comfort of comfortValues"
                    [value]="comfort.id">
                    {{comfort.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div>
              <mat-form-field appearance="outline" class="width-50" formGroupName="default">
                <mat-label>{{project?.seatOccupancyrateLabel}}</mat-label>
                <input matInput autoComplete="off" type="number" min="1" step="1" (keypress)="disableKeyPressEnter($event)"
                  formControlName="seatOccupancyRateDefault">
                <!-- <mat-error *ngIf="projectForm.get('defaultOccupancyRate')?.hasError('min')">
                        {{project?.validation?.minValue1}}
                    </mat-error>
                    <mat-error *ngIf="projectForm.get('defaultOccupancyRate')?.hasError('max')">
                        {{project?.validation?.maxValue100}}
                    </mat-error> -->
              </mat-form-field>
              <label class="margin-l-r-10">( Value from region:
                {{selectedRegionTransportModeDefault?.default?.seatOccupancyRateDefault}}% )</label>
            </div>

            <div>
              <mat-form-field appearance="outline" class="width-50" formGroupName="default">
                <mat-label>{{project?.standingPlaceOccupancyRateLabel}}</mat-label>
                <input matInput autoComplete="off" type="number" (keypress)="disableKeyPressEnter($event)" min="1"
                  step="1" formControlName="standingOccupancyRateDefault">
                <!-- <mat-error *ngIf="projectForm.get('standingPlaceOccupancyRate')?.hasError('min')">
                      {{project?.validation?.minValue1}}
                  </mat-error>
                  <mat-error *ngIf="projectForm.get('standingPlaceOccupancyRate')?.hasError('max')">
                      {{project?.validation?.maxValue100}}
                  </mat-error>
                  <mat-error *ngIf="projectForm.get('standingPlaceOccupancyRate')?.hasError('required')">
                      {{project?.validation?.overwriteDefault}}
                  </mat-error> -->
              </mat-form-field>
              <label class="margin-l-r-10">( Value from region:
                {{selectedRegionTransportModeDefault?.default?.standingOccupancyRateDefault}}% )</label>
            </div>

            <div>
              <mat-form-field appearance="outline" formGroupName="default" class="margin-right">
                <mat-label>{{project?.personsBoardingLabel}}</mat-label>
                <input matInput type="number"
                  autoComplete="off" (keypress)="disableKeyPressEnter($event)" step="1"
                  formControlName="personsBoardingDefault" (input)="triggerValidatorUpdate()">
                <!-- <mat-error *ngIf="projectForm.get('personsPerSquareMeter')?.hasError('min')">
                                {{project?.validation?.minValue1}}
                            </mat-error>
                            <mat-error *ngIf="projectForm.get('personsPerSquareMeter')?.hasError('max')">
                                {{project?.validation?.maxValue100}}
                            </mat-error>
                            <mat-error *ngIf="projectForm.get('personsPerSquareMeter')?.hasError('required')">
                                {{project?.validation?.required}}
                            </mat-error> -->
              </mat-form-field>
              <label *ngIf="projectForm.value.default.personValueFormatId==1" class="margin-l-r-10">( Value from
                region:
                {{selectedRegionTransportModeDefault?.default?.personsBoardingDefault}}%)</label>
              <mat-form-field appearance="outline" formGroupName="default" class="margin-right">
                <mat-label>{{project?.personsDeboardingLabel}}</mat-label>
                <input matInput type="number"
                  autoComplete="off" (keypress)="disableKeyPressEnter($event)"step="1"
                  formControlName="personsDeboardingDefault" (input)="triggerValidatorUpdate()">
                <!-- <mat-error *ngIf="projectForm.get('personsPerSquareMeter')?.hasError('min')">
                                  {{project?.validation?.minValue1}}
                              </mat-error>
                              <mat-error *ngIf="projectForm.get('personsPerSquareMeter')?.hasError('max')">
                                  {{project?.validation?.maxValue100}}
                              </mat-error>
                              <mat-error *ngIf="projectForm.get('personsPerSquareMeter')?.hasError('required')">
                                  {{project?.validation?.required}}
                              </mat-error> -->
              </mat-form-field>
              <label *ngIf="projectForm.value.default.personValueFormatId==1" class="margin-l-r-10">( Value from
                region:
                {{selectedRegionTransportModeDefault?.default?.personsDeboardingDefault}}%)</label>
              <span formGroupName="default">
                <mat-radio-group aria-labelledby="example-radio-group-label" formControlName="personValueFormatId">
                  <mat-radio-button class="example-radio-button" (click)="onPersonValueFormatClick(1)" [value]="1">
                    {{project?.percentLabel}}
                  </mat-radio-button>
                  <mat-radio-button class="example-radio-button" (click)="onPersonValueFormatClick(2)" [value]="2">
                    {{project?.absoluteLabel}}
                  </mat-radio-button>
                </mat-radio-group>
              </span>
            </div>

            <div>
              <mat-form-field appearance="outline" class="width-50" formGroupName="default">
                <mat-label>{{project?.personsPerSquareMeterEntranceArea}}</mat-label>
                <input matInput type="number" autoComplete="off" (keypress)="disableKeyPressEnter($event)" min="0"
                  max="8" formControlName="personsPerSquareMeterEntranceArea">
                <!-- <mat-error *ngIf="projectForm.get('personsPerSquareMeter')?.hasError('min')">
                        {{project?.validation?.minValue1}}
                    </mat-error>
                    <mat-error *ngIf="projectForm.get('personsPerSquareMeter')?.hasError('max')">
                        {{project?.validation?.maxValue100}}
                    </mat-error>
                    <mat-error *ngIf="projectForm.get('personsPerSquareMeter')?.hasError('required')">
                        {{project?.validation?.required}}
                    </mat-error> -->
              </mat-form-field>
              <label class="margin-l-r-10">( Value from region:
                {{selectedRegionTransportModeDefault?.default?.personsPerSquareMeterEntranceArea}}
                Persons/m²)</label>
            </div>

            <div>
              <mat-form-field appearance="outline" class="width-50" formGroupName="default">
                <mat-label>{{project?.personsPerSquareMeterMultiPurposeArea}}</mat-label>
                <input matInput type="number" autoComplete="off" (keypress)="disableKeyPressEnter($event)"
                  formControlName="personsPerSquareMeterMultiPurposeArea" min="0" max="8">
                <!-- <mat-error *ngIf="projectForm.get('personsPerSquareMeter')?.hasError('min')">
                          {{project?.validation?.minValue1}}
                      </mat-error>
                      <mat-error *ngIf="projectForm.get('personsPerSquareMeter')?.hasError('max')">
                          {{project?.validation?.maxValue100}}
                      </mat-error>
                      <mat-error *ngIf="projectForm.get('personsPerSquareMeter')?.hasError('required')">
                          {{project?.validation?.required}}
                      </mat-error> -->
              </mat-form-field>
              <label class="margin-l-r-10">( Value from region:
                {{selectedRegionTransportModeDefault?.default?.personsPerSquareMeterMultiPurposeArea}}
                Persons/m²)</label>
            </div>

            <div>
              <mat-form-field appearance="outline" class="width-50" formGroupName="default">
                <mat-label>{{project?.personsPerSquareMeterAisle}}</mat-label>
                <input matInput type="number" autoComplete="off" (keypress)="disableKeyPressEnter($event)"
                  formControlName="personsPerSquareMeterAisle" min="0" max="8">
                <!-- <mat-error *ngIf="projectForm.get('personsPerSquareMeter')?.hasError('min')">
                          {{project?.validation?.minValue1}}
                      </mat-error>
                      <mat-error *ngIf="projectForm.get('personsPerSquareMeter')?.hasError('max')">
                          {{project?.validation?.maxValue100}}
                      </mat-error>
                      <mat-error *ngIf="projectForm.get('personsPerSquareMeter')?.hasError('required')">
                          {{project?.validation?.required}}
                      </mat-error> -->
              </mat-form-field>
              <label class="margin-l-r-10">( Value from region:
                {{selectedRegionTransportModeDefault?.default?.personsPerSquareMeterAisle}} Persons/m² )</label>
            </div>

            <div>
              <mat-checkbox *ngIf="showReservationNeeded" formControlName="reservationNeeded" class="margin-right">
                {{project?.checkBoxSeatReservation}}</mat-checkbox>
            </div>

            <div>
              <button mat-raised-button class="button color" (click)="openAgeGenderMatrix()">Age Gender
                Distribution</button>
            </div>

          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </form>
  </mat-card-content>
  <div class="content-buttons">
    <button mat-raised-button class="color" (click)="navigateBack()">{{project?.buttonBack}}</button>
    <div class="spacer"></div>
    <button mat-raised-button class="color" (click)="onSubmit()"
      [disabled]="!projectForm.valid">{{project?.buttonSave}}</button>
  </div>
</div>
<hr class="line">